import { FindDonationsParams, StandardDonation } from '@domains';
import { createAction, props } from '@ngrx/store';

export enum StandardDonationActionType {
  GetStandardDonations = '[StandardDonation] Get Standard Donations',
  GetStandardDonationsSuccess = '[StandardDonation] Get Standard Donations Success',
  GetStandardDonation = '[StandardDonation] Get Standard Donation',
  GetStandardDonationSuccess = '[StandardDonation] Get Standard Donation Success',
}

export const getStandardDonations = createAction(
  StandardDonationActionType.GetStandardDonations,
  props<{ findParams: FindDonationsParams; keep?: boolean }>(),
);
export const getStandardDonationsSuccess = createAction(
  StandardDonationActionType.GetStandardDonationsSuccess,
  props<{ resultsCount: number; results: Array<StandardDonation> }>(),
);
export const getStandardDonation = createAction(StandardDonationActionType.GetStandardDonation, props<{ id: string }>());
export const getStandardDonationSuccess = createAction(
  StandardDonationActionType.GetStandardDonationSuccess,
  props<{ standardDonation: StandardDonation }>(),
);
